<template>
  <div :class="classList" class="file-upload-container">
    <label v-if="label" class="d-flex">
      {{ label.trim().replace(/\*$/, "") }}
      <span v-if="isFileSubmitted">
        <i class="material-icons check-icon"> check_circle </i>
      </span>
      <span v-else-if="isRequired" class="asterisk-mark">*</span>
      <a
        v-if="blankFileUrl"
        :href="blankFileUrl"
        class="download-blank-template"
        v-tooltip="'Download Blank Template'"
        target="_blank"
      >
        <i class="material-icons"> download </i>
      </a>
    </label>
    <div
      v-if="adminDescription && $store.getters.isAgent"
      class="admin-description"
    >
      <div v-html="adminDescription"></div>
    </div>
    <div v-if="description" class="description">
      <div v-html="description"></div>
    </div>
    <input
      v-if="isImage"
      type="file"
      :id="uploadFileId"
      style="display: none"
      @change="onChange"
      ref="file"
      accept="image/x-png,image/jpeg"
      :disabled="isDisabled"
    />
    <input
      v-else-if="isDoc"
      type="file"
      :id="uploadFileId"
      style="display: none"
      @change="onChange"
      ref="file"
      accept=".pdf,.doc,.docx"
      :disabled="isDisabled"
    />
    <input
      v-else
      type="file"
      :id="uploadFileId"
      style="display: none"
      @change="onChange"
      ref="file"
      :disabled="isDisabled"
    />

    <div
      class="center py-4 px-3"
      :class="{
        'document-section': !hideBorder,
        'required-section': isRequired && submitClicked && !isFileSubmitted,
      }"
    >
      <div class="download-blank-template">
        <a
          v-if="blankFileUrl"
          :href="blankFileUrl"
          v-tooltip="'Download Blank Template'"
          target="_blank"
        >
          <i class="material-icons"> download </i>
        </a>
        <a
          v-if="isFileSubmitted"
          :href="convertToAbsolutePath(inputVal)"
          v-tooltip="'Open in New Tab'"
          target="_blank"
        >
          <i class="material-icons"> launch </i>
        </a>
      </div>
      <div v-if="isFileSubmitted" class="uploaded-button-container">
        <PDFButton
          buttonClass="mylisting-button dark-button view-button"
          :urlLink="convertToAbsolutePath(inputVal)"
          buttonText="View"
          @buttonInput="
            showFilePreviewDialog({
              url: convertToAbsolutePath(inputVal),
            })
          "
        >
        </PDFButton>
        <p
          class="delete-text delete-doc-button"
          @click="showDeleteDocumentConfirmDialog()"
        >
          {{ getLabelByKeys("BUTTONS.DELETE") }}
        </p>
      </div>
      <div v-else>
        <button
          class="mylisting-button dark-button"
          @click="$refs.file.click()"
        >
          {{ uploadLabel || "Upload" }}
        </button>
      </div>
    </div>
    <div
      class="result-section"
      v-if="selectFile != null && selectFile.name != null"
    >
      <span class="file-label">
        {{ getLabelByKeys("FILE_UPLOAD.FILE") }}:
      </span>
      <span>{{ selectFile.name }}</span>
    </div>

    <p
      class="required-message"
      v-if="!isFileSubmitted && submitClicked && isRequired"
    >
      {{ getLabelByKeys("ERROR_MESSAGES.FIELD_REQUIRED") }}
    </p>
    <p
      class="required-message"
      v-if="
        selectFile != null && selectFile.size > maxSizeInByte && submitClicked
      "
    >
      {{ getLabelByKeys("FILE_UPLOAD.FILE_EXCEED_MAXIMUM", maxSize) }}
    </p>
    <div class="remark" v-if="remark" v-html="remark"></div>
  </div>
</template>
<script>
import {
  VALID_DOC_FILE_TYPE,
  VALID_IMAGE_FILE_TYPE,
} from "../../../constants/file-type";

import { FILE_TYPES } from "../../../constants/custom-define-type";
import PDFButton from "../PDFButton.vue";
import axios from "axios";

export default {
  name: "FileWithLabel",
  props: {
    /* Name of the component*/
    name: String,
    label: String,
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12",
    },
    // Description which are only visible to admin
    adminDescription: String,
    // Description below label
    description: String,
    // Mark if the field is required
    isRequired: {
      type: Boolean,
      default: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    value: [File, String],
    // Remark at the end of component
    remark: String,
    // Maximum file size in MB
    maxSize: {
      type: Number,
      default: 100,
    },
    fileType: String,
    initialUrl: String,
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false,
    },
    // Info if submit file to server after upload
    submitInfo: Object,
    blankFileUrl: String,
    builderField: Object,
    uploadLabel: String,
    hideBorder: Boolean,
  },
  components: {
    PDFButton,
  },
  data() {
    return {
      selectFile: this.value,
      imageUrl: this.initialUrl,
    };
  },
  created() {
    if (typeof this.value === "string") {
      this.imageUrl = this.convertToAbsolutePath(this.value);
    }
    if (this.initialUrl && !this.value) {
      this.inputVal = this.initialUrl;
    }
  },
  computed: {
    maxSizeInByte() {
      return this.maxSize * 1024 * 1024;
    },
    isDoc() {
      return this.fileType === FILE_TYPES.DOCUMENT;
    },
    isImage() {
      return this.fileType === FILE_TYPES.IMAGE;
    },
    uploadFileId() {
      return `upload-file-id-${this._uid}-${this.name}`;
    },
    isFileSubmitted() {
      return this.inputVal;
    },
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        if (val && this.field) {
          val.name = this.field.label;
        }
        this.$emit("input", val);
      },
    },
  },
  methods: {
    async onChange() {
      let selectFile = this.$refs.file.files[0];
      if (selectFile == null) {
        return;
      }
      if (selectFile.size === 0) {
        this.showErrorDialog(this.$store.getters.emptyFileError);
        this.selectFile = null;
      } else if (selectFile.size > this.maxSizeInByte) {
        this.showErrorDialog(this.$store.getters.fileSizeExceedLimitError);
        this.selectFile = null;
      } else if (
        this.isImage &&
        !VALID_IMAGE_FILE_TYPE.includes(selectFile.type)
      ) {
        this.showErrorDialog(this.$store.getters.invalidImageFileTypeError);
        this.selectFile = null;
      } else if (this.isDoc && !VALID_DOC_FILE_TYPE.includes(selectFile.type)) {
        this.showErrorDialog(this.$store.getters.invalidDocFileTypeError);
        this.selectFile = null;
      } else {
        this.selectFile = selectFile;
      }

      if (this.isImage) {
        if (this.selectFile == null) {
          this.imageUrl = null;
        } else {
          this.imageUrl = URL.createObjectURL(this.selectFile);
        }
      }

      // Upload file to server
      const formData = new FormData();
      formData.append("file", selectFile);
      formData.append("agency", this.$store.getters.agencyID);
      if (this.submitInfo.profileBuilder) {
        formData.append("profile-builder", this.submitInfo.profileBuilder);
      }
      if (this.submitInfo.email) {
        formData.append("email", this.submitInfo.email);
      }
      if (this.submitInfo.type) {
        formData.append("type", this.submitInfo.type);
      }
      if (this.builderField && this.builderField.category) {
        formData.append("category", this.builderField.category);
      }
      const uploadFileRes = await axios.post(`/upload-files/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (uploadFileRes && uploadFileRes.data) {
        const fileURL = uploadFileRes.data.file;
        this.$store.dispatch("addUploadedFileUrlName", {
          url: fileURL,
          name: this.selectFile.name,
        });
        this.inputVal = fileURL;
      }
      this.$refs.file.value = "";
    },
    showDeleteDocumentConfirmDialog() {
      this.showConfirmDialog({
        ...this.$store.getters.deleteFileConfirmDialog,
        onAcceptCallback: () => {
          this.inputVal = null;
        },
      });
    },
  },
};
</script>

<style scoped>
.check-icon {
  font-size: 14px;
  margin-left: 5px;
  /* color: #444; */
  color: green;
}
@media (max-width: 480px) {
  .btn-desktop-visible {
    display: none;
  }
}

@media (min-width: 481px) {
  .btn-mobile-visible {
    display: none;
  }
}

.document-section {
  border: 1px solid var(--bootstrapgrey);
  border-radius: 3px;
  position: relative;
}

.required-section {
  border: 1px solid red;
}

.required-star {
  color: red;
}

.view-button {
  color: white;
}

.uploaded-button-container {
  margin-top: -4px;
}

.view-button-container {
  display: inline-block;
  margin-top: 4px;
}

.delete-doc-button {
  margin-top: 13px;
}

.view-file-button {
  width: 12em;
  margin-top: 1em;
}

.view-info-button {
  width: 12em;
  margin-top: 1em;
}

.expiration-info {
  margin-top: -0.5rem;
  margin-bottom: 0.8rem;
}

.expiration-info > span {
  /* border: solid 1px var(--coredarkercolor); */
  color: var(--coredarkercolor);
  border-radius: 0.4rem;
  padding: 0.3rem;
}

.expiration-info.expired > span {
  border: solid 1px red;
  color: red;
}

.uploaded-time {
  font-size: 0.8em;
  margin-top: -0.3em;
  margin-bottom: 0.5em;
}

.download-blank-template {
  top: 0;
  right: 0;
  cursor: pointer;
  position: absolute;
}
.download-blank-template.second-btn {
  right: 22px;
}
.background-check-section .background-check {
  border: 1px solid var(--bootstrapgrey);
  border-radius: 3px;
  width: fit-content;
  padding: 1rem 2rem;
  text-align: center;
}
.background-check-section .background-check .image {
  width: 200px;
}
.background-check-section .background-check .image img {
  width: 100%;
}
.background-check-modal-text {
  font-size: 1.5rem;
}
.background-modal-buttons {
  display: flex;
  justify-content: space-between;
}
.powered-text {
  font-size: 12px;
}
@media print {
  .no-pagebreak {
    break-inside: avoid;
  }
}

.expired-info {
  font-weight: bold;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/common/form-elements/FileWithLabel.vue